import type { Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

/**
 * MUI StyleSheet 를 inline 에서 쓰는 용도입니다.
 */
export namespace MUIStyleSheet {
  type NamedStyles<T> = Readonly<{ [P in keyof T]: SystemStyleObject<Theme> }>;

  export const create = <T extends NamedStyles<T> | NamedStyles<unknown>>(styles: T): T => {
    return styles;
  };
}
